import clsx from 'clsx';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import {
  DEFAULT_STATES,
  ERROR_STATES,
  SUCCESSFUL_STATES,
  WARNING_STATES,
  WIP_STATES,
} from '../../orders/models/OrderModel';
import { PlanStateEnum } from '../../plans/models/PlanModel';

type Props = {
  state: string | null;
  kind: 'plan' | 'order';
};

function planClass(state: string) {
  if (state === PlanStateEnum.ACTIVE) {
    return 'badge-light-success';
  }
  if (state === PlanStateEnum.PROPOSAL) {
    return 'badge-light-warning';
  }
  return 'badge-light-danger';
}

function orderClass(state: string) {
  return clsx(
    SUCCESSFUL_STATES.includes(state as any) && 'badge-light-success',
    WIP_STATES.includes(state as any) && 'badge-light-dark',
    DEFAULT_STATES.includes(state as any) && 'badge-light-primary',
    WARNING_STATES.includes(state as any) && 'badge-light-warning',
    ERROR_STATES.includes(state as any) && 'badge-light-danger'
  );
}

/** A plan or order state, in Spanish, with the CRM's colours. */
const StateBadge: FC<Props> = ({ state, kind }) => {
  const intl = useIntl();

  if (!state) {
    return (
      <span className="badge badge-light-info">
        {intl.formatMessage({ id: 'quickSale.projected' })}
      </span>
    );
  }

  const prefix = kind === 'plan' ? 'quickSalePlanState' : 'quickSaleOrderState';

  return (
    <span
      className={clsx(
        'badge',
        kind === 'plan' ? planClass(state) : orderClass(state)
      )}
    >
      <span className="bullet bullet-dot bg-current me-2 h-6px w-6px" />
      {intl.formatMessage({ id: `${prefix}.${state}`, defaultMessage: state })}
    </span>
  );
};

export { StateBadge };
